export default __webpack_public_path__ + "static/media/close-2.182581b0.svg";